import { render, staticRenderFns } from "./WhatsAppPieChart.vue?vue&type=template&id=355031a0"
import script from "./WhatsAppPieChart.vue?vue&type=script&lang=js"
export * from "./WhatsAppPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports